import $ from "jquery";
import ClipboardJS from "clipboard";
import * as utils from './utils';
import tip from './tip';
import errorTip from "./errorTip";
import { LOGIN_PAGE_PC, LOGIN_PAGE_MOBILE, LOGOUT_URL } from './api';
import bagTip from "./bagTip";
import luckydog from "./luckydog";

const URL = `//${window.location.host}/gm992021/img/`;

// 设置签到按钮
/**
 * status 0: 今日已簽到
 * status 1: 馬上簽到，開啟寶箱 >
 * status 2: 点击领取累计签到礼包  >
 * @returns 
 */
export const setSignBtn = function (status) {
  if (status < 0 || status > 2 || typeof status !== 'number') {
    throw new Error('Param should be limit 0 to 2!');
  }
  const $openBox = $('.j-open-box');
  const text = ['今日已簽到', '馬上簽到，開啟寶箱 >', '点击领取累计签到礼包  >'];
  $openBox.text(text[status]);
  status == 0 ? $openBox.addClass('grey-btn') : $openBox.removeClass('grey-btn');
  status == 2 ? $openBox.addClass('final') : $openBox.removeClass('final');
}

// 设置奖励状态
export const setBoxStatus = function (boxIndex, boxStatus, clear = false) {
  const STATUS_ARR = ['get', 'got', 'two', 'three', 'to-three'];
  const $award = $(`.j-award-${boxIndex}`);
  const $tip = $(`.j-tip-${boxIndex}`);
  // 输入校验
  if (![1, 2, 3, 4].includes(boxIndex) || !STATUS_ARR.includes(boxStatus) || typeof clear !== 'boolean') {
    throw new Error('param error');
  }
  // 清空状态
  $award.removeClass('shadow');
  for (let i = 0, length = STATUS_ARR.length; i < length; i++) {
    $tip.removeClass(`tip-${STATUS_ARR[i]}`);
  }
  // 只清空状态
  if (clear) {
    return;
  }
  // 设置状态
  $award.addClass('shadow');
  $tip.addClass(`tip-${boxStatus}`);
}

// 设置签到时间
export const setSignTime = function (day) {
  if (typeof day !== 'number') {
    throw new Error('param type is not a number');
  }
  if (day <= 0) {
    $('.j-sign-text').text('您暫未簽到');
    $('.j-sign-day').text('');
    return;
  }
  $('.j-sign-text').text('當前已簽到');
  $('.j-sign-day').text(day + '天！');
}

// 设置抽奖次数
export const setEggTime = function (time, notime = false) {
  if (typeof time !== 'number' || typeof notime !== 'boolean') {
    throw new Error('param type is error');
  }
  const $eggTime = $('.j-egg-time');
  const $eggText = $('.j-egg-text');
  if (notime) {
    $eggTime.hide();
    $eggText.removeClass('time').addClass('notime');
    return;
  }
  $eggTime.text(time).show();
  $eggText.removeClass('notime').addClass('time');
}

export const setStartGameDisable = function (bool = true) {
  if (typeof bool !== 'boolean') {
    throw new Error('param type should boolean');
  }
  const $start = $('.j-egg-start');
  bool ? $start.addClass('disable-btn') : $start.removeClass('disable-btn');
}

// 设置奖励列表
export const setAwardList = function (gameId = 52) {
  gameId += '';
  let tpl = '';
  let count = 0;
  let gameAward = bagTip[gameId];
  let keyArr = Object.keys(gameAward);
  // console.log(gameId, gameAward);
  for (let i = 0, length = keyArr.length; i < length; i++) {
    if (/lottery/.test(keyArr[i])) {
      if (++count > 5) {
        break;
      }
      // console.log(gameAward[keyArr[i]]);
      tpl += `
        <div class="swiper-slide item">
          <div class="item-img">
            <img src="${URL}${gameAward[keyArr[i]].img || 'default-award.png'}" alt="">
          </div>
          <p class="item-name">${gameAward[keyArr[i]].content}</p>
        </div>`;
    }
  }
  // console.log(tpl);
  $('.j-award-list').html(tpl);
  window.activity.swiperAward && window.activity.swiperAward.update();
}

// 显示弹窗
export const showPopup = function (popupName) {
  popupName = popupName === 'login' ? 'tip' : popupName;
  _checkPopupName(popupName);
  $('.j-full-shadow').fadeIn(100);
  window.activity.$activePopup = $(`.j-popup-${popupName}`).fadeIn(100);
  window.activity.activePopupName = popupName;
}

// 关闭弹窗
export const hidePopup = function (popupName) {
  popupName = popupName === 'login' ? 'tip' : popupName;
  _checkPopupName(popupName);
  $('.j-full-shadow').fadeOut(100);
  $(`.j-popup-${popupName}`).fadeOut(100);
  window.activity.$activePopup = null;
  window.activity.activePopupName = '';
}

/**
 * 奖励弹窗配置-折扣卷
 * @param data
 */

/**
<li class="ticket-item">
  <div class="img">
    <img src="" alt="">
  </div>
  <div class="info">
    <p class="info-name">遊戲名稱-禮包名稱</p>
    <p class="info-desc">禮包內容：XXX、XXX、XXX、XXX、XXX、XXX</p>
    <p class="info-code">禮包碼：39238FHEW</p>
    <a href="javascript:void(0);" class="info-btn j-copycode" data-code="123456">複製禮包碼</a>
  </div>
</li>

<li class="ticket-item">
  <div class="img">
    <img src="" alt="">
  </div>
  <div class="info">
    <p class="info-name">遊戲名稱-禮包名稱</p>
    <p class="info-desc">禮包內容：XXX、XXX、XXX、XXX、XXX、XXX</p>
    <p class="info-tip">禮包會在活動結束后48小時內發送到您指定的遊戲賬號內</p>
  </div>
</li>

{
  "is_card": 0,
  "date": "2021-09-01 16:17:26",
  "game_id": 52,
  "gift_key": "sign_total",
  "game": "叫我大掌櫃",
  "card": ""
},
{
  "is_card": 1,
  "date": "2021-09-01 16:17:26",
  "game_id": 52,
  "gift_key": "lottery_52_1",
  "game": "叫我大掌櫃",
  "card": "duewhfw"
}
 */
let clipboardPopup = null;
export const setAwardPopupTicket = function (data) {
  clipboardPopup && clipboardPopup.destroy();
  let tpl = '';
  for (let i = 0, length = data.length; i < length; i++) {
    let game = bagTip[data[i].game_id];
    let gift_key = data[i].gift_key;
    let img = game[gift_key].img || 'default-award.png';
    if (data[i].is_card == 1) {
      tpl += `
      <li class="ticket-item">
        <div class="img">
          <img src="${URL + img}" alt="">
        </div>
        <div class="info">
          <p class="info-name">${data[i].game}-${game[gift_key].name}</p>
          <p class="info-desc">禮包內容：${game[gift_key].content}</p>
          <p class="info-code">禮包碼：${data[i].card}</p>
          <a href="javascript:void(0);" class="info-btn j-copycode" data-clipboard-text="${data[i].card}">複製禮包碼</a>
        </div>
      </li>`;
    } else {
      tpl += `
      <li class="ticket-item">
        <div class="img">
          <img src="${URL + img}" alt="">
        </div>
        <div class="info">
          <p class="info-name">${data[i].game}-${game[gift_key].name}</p>
          <p class="info-desc">禮包內容：${game[gift_key].content}</p>
          <p class="info-tip">禮包會在活動結束后48小時內發送到您指定的遊戲賬號內。</p>
        </div>
      </li>`;
    }
  }
  $('.j-popup-ticketlist').html(tpl);

  // 背包弹窗复制
  clipboardPopup = new ClipboardJS('.j-copycode');
  clipboardPopup.on('success', (e) => {
    // console.log(e, 'copy sucess');
  })
  clipboardPopup.on('error', (e) => {
    // console.log(e, 'copy error');
  })
}
/**
 * 奖励弹窗配置-游戏礼包
 * @param data 
 */
export const setAwardPopupBag = function (data) {
  let tpl = '';
  for (let i = 0, length = data.length; i < length; i++) {
    // console.log(data[i]);
    let game = bagTip[data[i].game_id];
    let gift_key = data[i].gift_key;
    let img = game[gift_key].img || 'default-award.png';
    tpl += `
    <li class="bag-item">
      <div class="img">
        <img src="${URL + img}" alt="">
      </div>
      <div class="info">
        <p class="info-name">${game[gift_key].name}</p>
        <p class="info-text">可在${data[i].game}遊戲儲值中使用（自獲得起15天內有效）<br />${game[gift_key].name}</p>
        <p class="info-time"><a href="//mstore.gm99.com/points/#/coupon" class="info-time" target="_blank">前往查看</a></p>
      </div>
    </li>`;
  }
  $('.j-popup-baglist').html(tpl);
}

/**
 * 提示|登錄 彈窗配置： 类型 标题 重要信息 次要信息 按钮
 * @param {type, title, text, info, btn} config 
 */
export const setTipPopup = function (config) {
  if (!['tip', 'luckily', 'login'].includes(config.type)) {
    throw new Error('type is not exists');
  }
  // console.log(config.type);
  window.activity.popupHandlerType = config.type;
  let type = config.type === 'login' ? 'tip' : config.type;
  const PARENT_CLASS_NAME = `j-popup-${type}`;
  for (let key in config) {
    if (key === 'type') {
      continue;
    }
    const $ele = $(`.${PARENT_CLASS_NAME} .j-popup-${key}`);
    $ele && $ele.html(config[key]);
  }
}

/**
 * 选择弹窗配置：
 * @param {gameList serverList roleList} config 
 */
export const setSelectPopup = function (options, defaultSelect) {
  let { gameList, serverList, roleList } = options;
  let { gameSelect, serverSelect, roleSelect } = defaultSelect;
  let gameTpl, serverTpl, roleTpl;

  $('#game').html();
  $('#server').html();
  $('#role').html();
}

// 获取选项内容
export const getSelectOption = function () {
  return {
    game: $('#game').val(),
    server: $('#server').val(),
    role: $('#role').val()
  }
}

// 设置用户信息
export const setUserInfo = function (userName, boolLogin) {
  let deviceType = utils.deviceType();
  let isMobile = deviceType === 'android' || deviceType === 'ios';
  boolLogin ?
    $('.j-user').html(`歡迎你，${userName}<a href="javascript:void(0);" onclick="logout()" class="change-account">【登出】</a>`) :
    $('.j-user').html(`<a href="javascript:void(0);" onclick="login()" class="change-account">【登入】</a>`);
}


/**
 * 设置游戏信息
 * @param {*} boolSelected 
 * @param {*} game 
 * @param {*} server 
 * @param {*} role 
 * @returns 
 */
export const setGameInfo = function (boolSelected = true, game, server, role) {
  const $gameText = $('.j-game-text');
  const $changeGame = $('.j-change-game');
  if (boolSelected) {
    $changeGame.hide();
    $gameText.text(`您選擇參與活動的遊戲：${game}-${server}-${role}`);
    return;
  }
  $gameText.text('');
  $changeGame.show();
}

// 隐藏页面step3
export const hideStep3 = () => {
  const $bg = $('.j-bg');
  const $main = $('.j-main');
  let bgHeight = 0;
  let mainHeight = 0;
  if ($bg.data().device == 'pc') {
    let h = (4080 - 1056) / 1920 * 100 + 'vw';
    bgHeight = h;
    mainHeight = h;
  } else {
    let h = (3950 - 650) / 750 * 100 + 'vw';
    bgHeight = h;
    mainHeight = h;
  }
  $('.j-part3').hide();
  $('.j-nav-3').hide();
  $bg.css('height', bgHeight);
  $main.css('height', mainHeight);
}

// 设置中奖名单
export const setAwardName = (name, award) => {
  $('.j-award-name').html(
    `<p class="slide-up">恭喜玩家 ${name} 獲得獎勵 ${award}</p>`
  );
}
// 设置游戏，服务器，角色列表
export const setSelectOptions = ({
  type,
  data,
  defaultOptionValue,
  selectClassName,
  defaultOptionInnerText,
  optionValue,
  optionInnerText
}) => {
  // console.log(data);

  if (type == 'server') {
    window.gameInfo.server = {
      id: '',
      sid: '',
      name: ''
    }
    window.gameInfo.role = {
      id: '',
      name: ''
    }
  }
  if (type == 'role') {
    window.gameInfo.role = {
      id: '',
      name: ''
    }
  }

  if (data.length == 0) {
    $(`.${selectClassName}`).html(`<option value="">${defaultOptionInnerText}</option>`);
    return;
  }
  let fistrSelectTpl = '';
  let defaultSelectTpl = '';
  let boolDefaultOption = false;
  let defaultName = '';
  let sid = '';

  for (let i = 0, length = data.length; i < length; i++) {
    // 没有默认选项
    fistrSelectTpl += i == 0 ?
      `<option value="${data[i][optionValue]}" data-sid="${data[i].sid}" selected>${data[i][optionInnerText]}</option>` :
      `<option value="${data[i][optionValue]}" data-sid="${data[i].sid}">${data[i][optionInnerText]}</option>`;
    // 有默认选项
    if (data[i][optionValue] == defaultOptionValue) {
      boolDefaultOption = true;
      defaultName = data[i][optionInnerText];
      sid = data[i].sid;
      defaultSelectTpl += `<option value="${data[i][optionValue]}" data-sid="${data[i].sid}" selected>${data[i][optionInnerText]}</option>`
    } else {
      defaultSelectTpl += `<option value="${data[i][optionValue]}" data-sid="${data[i].sid}">${data[i][optionInnerText]}</option>`;
    }
  }
  // 更新全局数据，记录默认选中的gameId
  // console.log(boolDefaultOption ? defaultOptionValue : data[0][optionValue]);
  window.gameInfo[type].id = boolDefaultOption ? defaultOptionValue : data[0][optionValue];
  window.gameInfo[type].name = boolDefaultOption ? defaultName : data[0][optionInnerText];
  if (type == 'server') {
    window.gameInfo[type].sid = boolDefaultOption ? sid : data[0].sid;
  }
  $(`.${selectClassName}`).html(boolDefaultOption ? defaultSelectTpl : fistrSelectTpl);
  return Promise.resolve();
}

// 请求响应弹窗
export const errorHandler = ({ code, msg }) => {
  code += '';
  if (code == '-20001') {
    // console.log(tip.login);
    setTipPopup(tip.login);
    showPopup('login');
    return;
  }
  if (code == '-20016') {
    setTipPopup(tip.activityOver);
    showPopup('tip');
    return;
  }
  let text = errorTip[code] || "Fail";
  setTipPopup(tip.tipCommon(text));
  showPopup('tip');
}

// 得到中奖名单
export const setAwardPlayers = () => {
  let tpl = '';
  let players = luckydog();
  for (let i = 0, length = players.length; i < length; i++) {
    let name = players[i].name.slice(0, 4) + '***';
    tpl += `<p>恭喜 ${name} 獲得獎勵 ${players[i].gift}</p>`;
  }
  $('.j-award-name').html(tpl);
}

export const setGameStartStatus = (boolDisable) => {
  const $eggStrat = $('.j-egg-start');
  boolDisable ?
    $eggStrat.addClass('grey-btn') :
    $eggStrat.removeClass('grey-btn');
}

// 检查弹窗是否存在
function _checkPopupName(popupName) {
  if (!['award', 'rule', 'tip', 'luckily', 'select'].includes(popupName)) {
    throw new Error('popup name not fount');
  }
}

